// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState';
import { reducer as updateClienteReducer } from './updateCliente';
import { reducer as selectTipoTitularidadReducer } from './selectTipoTitularidad';
import { reducer as setHasPhysicalDocumentsReducer } from './setHasPhysicalDocuments';
import { reducer as getClienteReducer } from './getCliente';
import { reducer as syncHistoryReducer } from './syncHistory';
import { reducer as getPresupuestoReducer } from './getPresupuesto';
import { reducer as getAutoReducer } from './getAuto';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as addUsadoAEntregarReducer } from './addUsadoAEntregar/reducer';
import { reducer as removeUsadoAEntregarReducer } from './removeUsadoAEntregar';
import { reducer as initializeSubStateReducer } from './initializeSubState';
import { reducer as getSaleReducer } from './getSale/reducer';
import { reducer as getCotizacionReducer } from './getCotizacion/reducer';
import { reducer as selectStockReducer } from './selectStock';
import { reducer as updateSaleReducer } from './updateSale';
import { reducer as setStateReducer } from './setState';
import { reducer as setBonAdicional } from './setBonAdicional';
import { reducer as setBonEspecial } from './setBonEspecial';
import { reducer as setBonEspecialUsado } from './setBonEspecialUsado';
import { reducer as getPreciosReducer } from './getPrecios';
import { reducer as addBillsReducer } from './addBills/reducer';
import { reducer as updateBillsReducer } from './updateBills/reducer';

import { reducer as deleteBillsReducer } from './deleteBills/reducer';
import { reducer as setIsModified } from './setIsModified';
import { reducer as clearGestionOperativa } from './clearGestionOperativa';
import { reducer as validatePatentePeritadoGO } from './validatePatentePeritadoGO';
import { reducer as selectLineaFinancieraReducer } from './selectLineaFinanciera';
import { reducer as setMontoReducer } from './setMonto';
import { reducer as setFeesReducer } from './setFees';
import { reducer as updateTakingCarsReducer } from './updateTakingCars';
import { reducer as updateFinancingDataReducer } from './updateFinancingData';
import { reducer as getLineasFinancierasReducer } from './getLineasFinancieras';
import { reducer as getCostosPatentamientoReducer } from './getCostosPatentamiento';
import { reducer as solicitarPeritajeReducer } from './solicitarPeritaje';
import { reducer as getDescuentoInfoReducer } from './getDescuentoInfo';
import { reducer as getGastosDeEntregaCheckedReducer } from './getGastosDeEntregaChecked';
import { reducer as setAdditionalBonEditable } from './setAdditionalBonEditable';
import { reducer as setSpecialBonEditable } from './setSpecialBonEditable';
import { reducer as setExtraBonEditable } from './setExtraBonEditable';
import { reducer as getPeritajeReducer } from './getPeritaje/reducer';
import { reducer as setUsedTakeAmount } from "./setUsedTakeAmount";
import { reducer as calculateRemaining } from "./calculateRemaining/reducer";
import { reducer as clearPatente } from "./clearPatente";
import { reducer as reportSales } from "./reportSales";
import { reducer as saveCommentsReducer } from './saveComments';
import { reducer as openCommentDrawerReducer } from './openCommentDrawer';
import { reducer as closeCommentDrawerReducer } from './closeCommentDrawer';
import { reducer as changedClientReducer } from './changedClient/reducer';
import { reducer as retryOfferDMSReducer } from './retryOfferDMS/reducer';
import { reducer as addPaymentsReducer } from './addPayments/reducer';
import { reducer as cleanUrlPaymentsReducer } from './cleanUrlPayments/reducer';
import { reducer as changeStateReducer } from './changeState/reducer';
import { reducer as reEnteredVehicleReducer } from './reEnteredVehicles/reducer';
import { reducer as editDeliveryCostsReducer } from './editDeliveryCosts/reducer';
import { reducer as clearOwnerFields } from './clearOwnerFields'

const reducers = [
  updateClienteReducer,
  selectTipoTitularidadReducer,
  setHasPhysicalDocumentsReducer,
  getClienteReducer,
  syncHistoryReducer,
  getPresupuestoReducer,
  getAutoReducer,
  addUsadoAEntregarReducer,
  removeUsadoAEntregarReducer,
  initializeSubStateReducer,
  getSaleReducer,
  getCotizacionReducer,
  getPeritajeReducer,
  selectStockReducer,
  updateSaleReducer,
  setStateReducer,
  getPreciosReducer,
  addBillsReducer,
  updateBillsReducer,
  deleteBillsReducer,
  setBonAdicional,
  setBonEspecial,
  setBonEspecialUsado,
  getPreciosReducer,
  setIsModified,
  clearGestionOperativa,
  validatePatentePeritadoGO,
  getPreciosReducer,
  selectLineaFinancieraReducer,
  setMontoReducer,
  setFeesReducer,
  updateTakingCarsReducer,
  updateFinancingDataReducer,
  getLineasFinancierasReducer,
  getCostosPatentamientoReducer,
  solicitarPeritajeReducer,  
  getDescuentoInfoReducer,
  getGastosDeEntregaCheckedReducer,
  setAdditionalBonEditable,
  setSpecialBonEditable,
  setExtraBonEditable,
  setUsedTakeAmount,
  calculateRemaining,
  clearPatente,
  reportSales,
  saveCommentsReducer,
  openCommentDrawerReducer,
  closeCommentDrawerReducer,
  changedClientReducer,
  retryOfferDMSReducer,
  addPaymentsReducer,
  cleanUrlPaymentsReducer,
  changeStateReducer,
  reEnteredVehicleReducer,
  editDeliveryCostsReducer,
  clearOwnerFields
];

export default function reducer(state = initialState, action = {}) {
  let newState;

  if (action.type === LOGOUT_USER) {
    newState = initialState;
  } else {
    newState = state;
  }
  
  return reducers.reduce((s, r) => r(s, action), newState);
}
